import {Component, Input} from '@angular/core';
import {AmountStatus, Competitor, RegistrationStatus} from "@model";
import {AbstractComponent} from "../../abstract.component";

@Component({
  selector: 'app-my-entry-status',
  templateUrl: './my-entry-status.component.html',
  styleUrl: './my-entry-status.component.scss',
  standalone: false,
})
export class MyEntryStatusComponent extends AbstractComponent{

  @Input() registrationConfirmed: boolean = false;
  @Input() isOwner: boolean = false;
  @Input() paymentStatus: AmountStatus = AmountStatus.NOT_PAID ;
  @Input() owner?: Competitor;

  constructor() {
    super();
  }

  protected readonly RegistrationStatus = RegistrationStatus;

}
